import React from 'react';
import { Flex } from '~/ui/flex/Flex';
import { Item, ItemDefinition, registry, RenderProps } from '../Item';
import { PHONE } from '../itemIds';
import { PhoneCall } from './PhoneCall';
import * as S from './styles';

interface Props {
  type?: string;
  name?: string;
  autoPlay?: boolean;
  mediaUrl?: string;
  subtitlesUrl?: string;
  showProgress?: boolean;
  audio?: string;
  photo?: string;
  personalization?: boolean;
}

export type PhoneDefinition = ItemDefinition<typeof PHONE, Props>;

export class Phone extends Item<typeof PHONE, Props> {
  protected render({
    id,
    type,
    autoPlay,
    mediaUrl,
    showProgress,
    children,
    name,
    photo,
    subtitlesUrl,
    personalization = false
  }: RenderProps<Props>) {
    if (type === 'audio') {
      return (
        <PhoneCall
          id={id}
          narration={mediaUrl as string}
          autoPlay={autoPlay as boolean}
          subtitlesUrl={subtitlesUrl as string}
          showProgress={showProgress}
          personalization={personalization}
          name={name}
          photo={photo}
        >
          {children}
        </PhoneCall>
      );
    }

    return (
      <Flex variant="center" className="phone" position="relative" my="md">
        <S.PhoneBackground className="phone-background" />
        <S.WrapperForChildren>{children && children}</S.WrapperForChildren>
      </Flex>
    );
  }
}

registry[PHONE] = Phone;
